import strftime from "strftime";

export default {
  mounted() {
    const utcTime = this.el.dateTime; // e.g. "2025-09-04T12:34:56Z"
    const format = this.el.dataset.format; // e.g. "%m/%d/%Y at %I:%M%p"
    const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    const localTime = new Date(utcTime).toLocaleString("en-US", { timeZone: userTimeZone });
    // Ex: 8/30/2025, 1:22:14 AM
    // If this is ok, we don't need strftime

    const formattedTime = strftime(format, new Date(localTime));

    this.el.textContent = formattedTime;
  },
};
